import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { TourStepsService } from '../services/tour-steps.service';
import { TourStep } from '../models/tour-step';

// The legacy <chart> declares @Input() chartTypeTour but its live template never binds it,
// so register the step on the rendered chart-header control ourselves.
@Directive({ selector: '[chartHeaderTourStep]' })
export class ChartHeaderTourStepDirective implements AfterViewInit {
  @Input('chartHeaderTourStep') step: TourStep;
  /** 'type' = the chart-type toggle; 'menu' = the ellipsis menu holding Raw Data / Export PDF. */
  @Input() chartHeaderTourTarget: 'type' | 'menu' = 'type';

  // These selectors depend on DOM order/classes in chart-header.component.html: the type-toggle
  // zen-menu trigger renders first, and the ellipsis trigger carries fa-ellipsis. A reorder there
  // silently breaks step registration.
  private static readonly SELECTORS = {
    type: 'chart-header zen-menu i.fa-regular:not(.fa-ellipsis)',
    menu: 'chart-header zen-menu i.fa-ellipsis',
  };

  constructor(private host: ElementRef<HTMLElement>, private tourSteps: TourStepsService) {}

  ngAfterViewInit() {
    if (this.step) this.register();
  }

  // chart-header renders after this directive's ngAfterViewInit, so retry briefly.
  private register(attempt = 0) {
    const selector = ChartHeaderTourStepDirective.SELECTORS[this.chartHeaderTourTarget];
    const icon = this.host.nativeElement.querySelector<HTMLElement>(selector);
    if (!icon) {
      if (attempt < 10) setTimeout(() => this.register(attempt + 1), 200);
      return;
    }
    const on = this.step.on ?? 'bottom';
    this.tourSteps.addStep(this.step.tourKey, {
      order: this.step.order,
      isRows: this.step.isRows,
      options: {
        title: this.step.title,
        text: this.step.text,
        attachTo: { element: icon, on },
        classes: on.includes('left') ? '-mx-5' : 'mx-5',
      },
    });
  }
}
